import { render, staticRenderFns } from "./Prizes.vue?vue&type=template&id=273b3b4f&"
import script from "./Prizes.js?vue&type=script&lang=js&"
export * from "./Prizes.js?vue&type=script&lang=js&"
import style0 from "./Prizes.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports